// removed by extract-text-webpack-plugin
module.exports = {"content":"_3wNVNO1o","nav":"_1J1Y7fX3","weekNav":"_1z4Bqwad","arrow":"_2kJiXAqO"};


//////////////////
// WEBPACK FOOTER
// ./src/client/webapp/components/MobileWeekTable/MobileWeekTable.styl
// module id = 406
// module chunks = 0